module.exports = __webpack_public_path__ + "static/img/LOGO.ef79db2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/KerbalSpaceProgram/LOGO.png
// module id = 9fw+
// module chunks = 0